import { useQuery } from '@tanstack/react-query';
import { splitEvery } from 'ramda';
import { useIntl } from 'react-intl';

import { fetchVenueAvailabilityStatuses } from 'apis/restaurant-api/merchant-admin/venue/api';

const VENUE_ID_CHUNK_SIZE = 500;
const REFETCH_INTERVAL = 60 * 5 * 1000; // 5 minute

const useVenueAvailabilityStatus = (venueIds: string[]) => {
  const intl = useIntl();
  const {
    data: venuesData,
    error,
    isLoading,
  } = useQuery(
    ['venue-availability-status', venueIds, intl.locale],
    async () => {
      // Split into chunks to avoid hitting request timeout
      const venueIdChunks = splitEvery(VENUE_ID_CHUNK_SIZE, venueIds);
      const results = await Promise.all(
        venueIdChunks.map(chunk => fetchVenueAvailabilityStatuses({ venueIds: chunk }, intl.locale)),
      );
      return results.flat();
    },
    {
      refetchInterval: REFETCH_INTERVAL,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    },
  );
  return {
    venuesData,
    error,
    isLoading,
  };
};

export default useVenueAvailabilityStatus;
